import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';

import { selectPageType, selectQueryParams } from '../selectors';
import { TTrackingParamsType } from '../types/page/trackingParamsType';

export const useTrackingParams = (): TTrackingParamsType => {
  const isDesktop = useIsDesktop();

  const { source } = useSelector(selectQueryParams);
  const pageType = useSelector(selectPageType);
  const siteType = isDesktop ? 'desktop' : 'mobile';

  return {
    siteType,
    dealType: pageType,
    cianSource: source,
  };
};
